// extracted by mini-css-extract-plugin
export var arrow = "SimpleDocumentCard-module--arrow--a9187";
export var arrowNo = "SimpleDocumentCard-module--arrow_no--92acf";
export var arrowYes = "SimpleDocumentCard-module--arrow_yes--eebf4";
export var documentCardColumn = "SimpleDocumentCard-module--documentCardColumn--0953d";
export var documentCardLink = "SimpleDocumentCard-module--documentCardLink--f5d6a";
export var documentTitle = "SimpleDocumentCard-module--documentTitle--9d4c4";
export var flex = "SimpleDocumentCard-module--flex--5b542";
export var flex1 = "SimpleDocumentCard-module--flex_1--4fc37";
export var flexCenter = "SimpleDocumentCard-module--flex_center--d0086";
export var flexCenterCol = "SimpleDocumentCard-module--flex_center_col--cd66b";
export var flexCol = "SimpleDocumentCard-module--flex_col--9c878";
export var flexFixCenterCol = "SimpleDocumentCard-module--flex_fix_center_col--29c44";
export var flexFixedCenterCol = "SimpleDocumentCard-module--flex_fixed_center_col--05521";
export var hidden = "SimpleDocumentCard-module--hidden--a8cd4";
export var image = "SimpleDocumentCard-module--image--500ed";
export var publishingContainer = "SimpleDocumentCard-module--publishingContainer--f86d6";
export var publishingInformationLabel = "SimpleDocumentCard-module--publishingInformationLabel--c346a";
export var rotating = "SimpleDocumentCard-module--rotating--6738e";